import { render, staticRenderFns } from "./AdminYearFilter.vue?vue&type=template&id=ddc835e8&scoped=true&"
import script from "./AdminYearFilter.vue?vue&type=script&lang=js&"
export * from "./AdminYearFilter.vue?vue&type=script&lang=js&"
import style0 from "./AdminYearFilter.vue?vue&type=style&index=0&id=ddc835e8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddc835e8",
  null
  
)

export default component.exports